
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"60","height":"60"}, attrs),
              ...rest,
            },
            children.concat([_c('ellipse',{attrs:{"cx":"7.09","cy":"19.66","rx":"5.59","ry":"5.55","fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2"}}),_c('ellipse',{attrs:{"cx":"52.91","cy":"19.66","rx":"5.59","ry":"5.55","fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2"}}),_c('ellipse',{attrs:{"cx":"20.67","cy":"7.05","rx":"5.59","ry":"5.55","fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2"}}),_c('ellipse',{attrs:{"cx":"39.33","cy":"7.05","rx":"5.59","ry":"5.55","fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2"}}),_c('path',{attrs:{"d":"M41.73 26.94c-3.83-4.71-8.34-8.26-11.73-8.26-7.26 0-19.57 16.19-19.57 25.38A5.58 5.58 0 0016 49.61c2.95 0 5.9-2.06 9.34-3.28","fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2"}}),_c('ellipse',{attrs:{"cx":"41.28","cy":"42.7","rx":"15.91","ry":"15.8","fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2"}}),_c('path',{attrs:{"fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2","d":"M35.32 48.62l11.93-11.85M47.25 48.62L35.32 36.77"}})])
          )
        }
      }
    